export const ShareTabs = {
  SHARING_LINK: 'SHARING_LINK',
  CANVAS_LIBRARY: 'CANVAS_LIBRARY',
  COLLABORATORS: 'COLLABORATORS',
};
